import sendIcon from '/src/assets/send.svg';
import sendIcon2 from '/src/assets/send2.svg';

export default function SendButtonImgChatbot({inputValueState='', isRecording=false}){

    return <>
        {inputValueState.length === 0 && isRecording ? 
            <img
              className="bot-utn-img"
              src={sendIcon2}
              alt="Enviar"
            />
          :
          <img
            className="bot-utn-img"
            src={inputValueState.length <= 3 ? sendIcon : sendIcon2}
            alt="Enviar"
            />}
    </>
}